module.exports = __webpack_public_path__ + "img/1490119566.681be5c3.jpg";